import EA from 'helpers/init';
import { SocialShareKit } from 'plugins/social-share-kit';
export default EA.Methods.socialShare = () => {
    SocialShareKit.init();
};